/**
 * Type of ingredients.
 */
export type OtherAlcoholType = 'CIDER' | 'FRUIT_WINE' | 'VERMOUTH';

export const OtherAlcoholType = {
  Cider: 'CIDER' as OtherAlcoholType,
  FruitWine: 'FRUIT_WINE' as OtherAlcoholType,
  Vermouth: 'VERMOUTH' as OtherAlcoholType,
};
